import SlotParentValue from '@/components/tableElements/SlotParentValue.vue';
import TaggedText from '@/components/tableElements/TaggedText.vue';
export default {
  name: 'ProductSegmentValue',
  emits: ['toggleChildren'],
  components: {
    SlotParentValue,
    TaggedText
  },
  props: {
    value: Object,
    collapsed: Boolean
  }
};